<template>
    <div>
        <app-page-header></app-page-header>

        <v-container grid-list-xl class="box">
            <v-layout
                row
                wrap
                align-center
                justify-center
                fill-height
            >
                <v-flex xs12 sm12 md10 lg10 xl8>

                    <!-- HEADER -->
                    <v-card
                        outlined
                        class="mb-5"
                    >
                        <v-progress-linear
                            v-if="loading"
                            indeterminate
                            color="primary"
                        />

                        <v-card-text class="py-4">
                            <v-row align="center">

                                <!-- TITLE -->
                                <v-col
                                    cols="12"
                                    md="7"
                                >
                                    <div class="d-flex align-center">
                                        <v-icon
                                            large
                                            class="mr-4"
                                            color="blue-grey darken-2"
                                        >
                                            mdi-message-text-outline
                                        </v-icon>

                                        <div>
                                            <div class="text-subtitle-1 font-weight-medium">
                                                Upravljanje besedila na prikazovalniku
                                                <template v-if="display">
                                                    {{ display.name }}
                                                </template>
                                            </div>

                                            <div
                                                v-if="display"
                                                class="text-body-2 grey--text text--darken-1"
                                            >
                                                Urejanje vsebine po posameznih vrsticah
                                                (največ {{ maxCharactersPerRow }} znakov)
                                            </div>

                                            <div
                                                v-else
                                                class="text-body-2 grey--text text--darken-1"
                                            >
                                                Izberite prikazovalnik
                                            </div>
                                        </div>
                                    </div>
                                </v-col>


                                <!-- DISPLAY SELECT + ON/OFF -->
                                <v-col
                                    cols="12"
                                    md="5"
                                >
                                    <v-select
                                        v-model="selectedDisplayUuid"
                                        :items="displayBoards"
                                        item-text="name"
                                        item-value="uuid"
                                        label="Prikazovalnik"
                                        outlined
                                        dense
                                        hide-details
                                        :loading="loading"
                                        :disabled="
                                            loading ||
                                            displayBoards.length === 0
                                        "
                                        @change="selectDisplay"
                                    />

                                    <div
                                        v-if="display"
                                        class="d-flex align-center justify-end mt-3"
                                    >
                                        <v-switch
                                            v-model="display.is_on"
                                            inset
                                            dense
                                            hide-details
                                            color="green"
                                            class="mt-0 pt-0"
                                            @change="markDirty"
                                        />

                                        <v-chip
                                            small
                                            :color="
                                                display.is_on
                                                    ? 'green'
                                                    : 'grey darken-1'
                                            "
                                            dark
                                            class="ml-2"
                                        >
                                            <v-icon
                                                left
                                                small
                                            >
                                                {{
                                                    display.is_on
                                                        ? 'mdi-power'
                                                        : 'mdi-power-off'
                                                }}
                                            </v-icon>

                                            {{
                                                display.is_on
                                                    ? 'PRIŽGAN'
                                                    : 'UGASNJEN'
                                            }}
                                        </v-chip>
                                    </div>
                                </v-col>

                            </v-row>


                            <!-- DISPLAY INFO -->
                            <v-row
                                v-if="display"
                                class="mt-1"
                            >
                                <v-col
                                    cols="12"
                                    class="py-0 text-right"
                                >
                                    <v-chip
                                        small
                                        outlined
                                        color="blue-grey"
                                    >
                                        {{ rows.length }}-vrstični prikazovalnik
                                    </v-chip>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>


                    <!-- LOADING -->
                    <v-card
                        v-if="loading && !display"
                        outlined
                    >
                        <v-card-text class="text-center pa-10">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                                size="48"
                            />

                            <div class="mt-4 grey--text">
                                Nalaganje prikazovalnikov ...
                            </div>
                        </v-card-text>
                    </v-card>


                    <!-- NO DISPLAYS -->
                    <v-alert
                        v-else-if="
                            !loading &&
                            displayBoards.length === 0
                        "
                        type="info"
                    >
                        Za to aplikacijo ni konfiguriranega nobenega
                        prikazovalnika.
                    </v-alert>


                    <!-- MAIN CONTENT -->
                    <v-row v-else-if="display">

                        <!-- LEFT -->
                        <v-col
                            cols="12"
                            lg="7"
                        >
                            <v-card outlined>

                                <v-card-title
                                    class="text-subtitle-1 font-weight-bold"
                                >
                                    VSEBINA PO VRSTICAH
                                </v-card-title>

                                <v-divider />


                                <v-card-text class="pa-0">

                                    <div
                                        v-for="row in rows"
                                        :key="row.id"
                                        class="display-row"
                                    >
                                        <v-row
                                            align="start"
                                            class="ma-0"
                                        >

                                            <!-- ROW NUMBER -->
                                            <v-col
                                                cols="12"
                                                sm="1"
                                                class="
                                                    d-flex
                                                    justify-center
                                                    align-start
                                                    pt-sm-8
                                                "
                                            >
                                                <v-avatar
                                                    size="40"
                                                    color="blue-grey lighten-5"
                                                >
                                                    <span
                                                        class="
                                                            font-weight-bold
                                                            blue-grey--text
                                                            text--darken-2
                                                        "
                                                    >
                                                        {{ row.row_number }}
                                                    </span>
                                                </v-avatar>
                                            </v-col>


                                            <!-- CONTENT -->
                                            <v-col
                                                cols="12"
                                                sm="11"
                                            >

                                                <!-- LABEL -->
                                                <div
                                                    class="
                                                        text-subtitle-2
                                                        mb-2
                                                    "
                                                >
                                                    {{
                                                        row.label ||
                                                        (
                                                            'Vrstica ' +
                                                            row.row_number
                                                        )
                                                    }}

                                                    <v-tooltip bottom>
                                                        <template
                                                            v-slot:activator="{
                                                                on,
                                                                attrs
                                                            }"
                                                        >
                                                            <v-icon
                                                                x-small
                                                                color="primary"
                                                                class="ml-1"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >
                                                                mdi-information
                                                            </v-icon>
                                                        </template>

                                                        <span>
                                                            Največ
                                                            {{ maxCharactersPerRow }}
                                                            znakov
                                                        </span>
                                                    </v-tooltip>
                                                </div>


                                                <!-- TEXT INPUT -->
                                                <v-text-field
                                                    v-model="row.text"
                                                    outlined
                                                    dense
                                                    :counter="
                                                        maxCharactersPerRow
                                                    "
                                                    :maxlength="
                                                        maxCharactersPerRow
                                                    "
                                                    hide-details="auto"
                                                    placeholder="Vnesite besedilo"
                                                    @input="markDirty"
                                                />


                                                <!-- COLOR -->
                                                <template
                                                    v-if="
                                                        hasColorSelection(row)
                                                    "
                                                >
                                                    <div
                                                        class="
                                                            text-caption
                                                            font-weight-medium
                                                            mt-4
                                                            mb-2
                                                        "
                                                    >
                                                        Barva besedila:
                                                    </div>

                                                    <v-btn-toggle
                                                        v-model="row.color"
                                                        mandatory
                                                        dense
                                                        class="color-toggle"
                                                        @change="markDirty"
                                                    >
                                                        <v-btn
                                                            v-for="
                                                                color in
                                                                row.allowed_colors
                                                            "
                                                            :key="color"
                                                            :value="color"
                                                            class="color-btn"
                                                            :class="
                                                                colorButtonClass(
                                                                    row,
                                                                    color
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                small
                                                                left
                                                                :color="
                                                                    colorIconColor(
                                                                        row,
                                                                        color
                                                                    )
                                                                "
                                                            >
                                                                mdi-circle
                                                            </v-icon>

                                                            {{
                                                                colorLabel(
                                                                    color
                                                                )
                                                            }}
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </template>


                                                <!-- DESCRIPTION -->
                                                <div
                                                    class="
                                                        text-caption
                                                        grey--text
                                                        text--darken-1
                                                        mt-2
                                                    "
                                                >
                                                    <template
                                                        v-if="
                                                            hasColorSelection(
                                                                row
                                                            )
                                                        "
                                                    >
                                                        Prikaže se v izbrani barvi
                                                    </template>

                                                    <template v-else>
                                                        Prikaže se kot navadno besedilo
                                                    </template>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>

                                </v-card-text>


                                <v-divider />


                                <!-- ACTIONS -->
                                <v-card-actions
                                    class="justify-end pa-4"
                                >
                                    <v-btn
                                        text
                                        color="grey darken-2"
                                        :disabled="
                                            !isDirty ||
                                            saving
                                        "
                                        @click="resetChanges"
                                    >
                                        <v-icon left>
                                            mdi-close
                                        </v-icon>

                                        PREKLIČI
                                    </v-btn>


                                    <v-btn
                                        color="primary"
                                        :loading="saving"
                                        :disabled="
                                            !isDirty ||
                                            saving
                                        "
                                        @click="save"
                                    >
                                        <v-icon left>
                                            mdi-content-save-outline
                                        </v-icon>

                                        SHRANI SPREMEMBE
                                    </v-btn>
                                </v-card-actions>

                            </v-card>
                        </v-col>


                        <!-- RIGHT -->
                        <v-col
                            cols="12"
                            lg="5"
                        >

                            <!-- PREVIEW -->
                            <v-card
                                outlined
                                class="mb-5"
                            >
                                <v-card-title
                                    class="text-subtitle-1 font-weight-bold"
                                >
                                    PREDOGLED PRIKAZOVALNIKA
                                </v-card-title>

                                <v-card-text>

                                    <div
                                        class="display-preview"
                                        :class="{
                                            'display-preview-off':
                                                display &&
                                                !display.is_on
                                        }"
                                    >

                                        <div
                                            v-for="row in rows"
                                            :key="'preview-' + row.id"
                                            class="preview-row"
                                        >
                                            <span
                                                class="preview-text"
                                                :class="
                                                    previewClass(row)
                                                "
                                            >
                                                {{ row.text || ' ' }}
                                            </span>

                                            <span
                                                class="preview-number"
                                            >
                                                {{ row.row_number }}
                                            </span>
                                        </div>


                                        <!-- OFF OVERLAY -->
                                        <div
                                            v-if="
                                                display &&
                                                !display.is_on
                                            "
                                            class="display-off-overlay"
                                        >
                                            <v-icon
                                                large
                                                color="white"
                                            >
                                                mdi-power-off
                                            </v-icon>

                                            <div class="mt-2">
                                                PRIKAZOVALNIK JE UGASNJEN
                                            </div>
                                        </div>

                                    </div>


                                    <!-- LEGEND -->
                                    <div class="legend mt-5">

                                        <div
                                            v-if="
                                                usedColors.indexOf(
                                                    'white'
                                                ) !== -1
                                            "
                                            class="legend-item"
                                        >
                                            <span
                                                class="
                                                    legend-dot
                                                    white-dot
                                                "
                                            ></span>

                                            <span>
                                                Belo besedilo
                                            </span>
                                        </div>


                                        <div
                                            v-if="
                                                usedColors.indexOf(
                                                    'red'
                                                ) !== -1
                                            "
                                            class="legend-item"
                                        >
                                            <span
                                                class="
                                                    legend-dot
                                                    red-dot
                                                "
                                            ></span>

                                            <span>
                                                Rdeče besedilo
                                            </span>
                                        </div>


                                        <div
                                            v-if="
                                                usedColors.indexOf(
                                                    'green'
                                                ) !== -1
                                            "
                                            class="legend-item"
                                        >
                                            <span
                                                class="
                                                    legend-dot
                                                    green-dot
                                                "
                                            ></span>

                                            <span>
                                                Zeleno besedilo
                                            </span>
                                        </div>

                                    </div>

                                </v-card-text>
                            </v-card>


                            <!-- NAVODILA -->
                            <v-card outlined>

                                <v-card-title
                                    class="text-subtitle-1 font-weight-bold"
                                >
                                    NAVODILA
                                </v-card-title>

                                <v-card-text>

                                    <!-- TEXT ROWS -->
                                    <div
                                        v-if="
                                            textRowNumbers.length > 0
                                        "
                                        class="info-row"
                                    >
                                        <v-avatar
                                            size="40"
                                            color="blue lighten-5"
                                            class="mr-3"
                                        >
                                            <v-icon color="primary">
                                                mdi-format-text
                                            </v-icon>
                                        </v-avatar>

                                        <div>
                                            <div class="font-weight-medium">
                                                {{ textRowsTitle }}
                                            </div>

                                            <div
                                                class="
                                                    text-caption
                                                    grey--text
                                                "
                                            >
                                                Prikazujejo samo besedilo
                                            </div>
                                        </div>
                                    </div>


                                    <!-- COLOR ROWS -->
                                    <div
                                        v-if="
                                            colorRowNumbers.length > 0
                                        "
                                        class="info-row"
                                    >
                                        <v-avatar
                                            size="40"
                                            color="blue-grey lighten-5"
                                            class="mr-3"
                                        >
                                            <v-icon
                                                color="blue-grey darken-2"
                                            >
                                                mdi-palette-outline
                                            </v-icon>
                                        </v-avatar>

                                        <div>
                                            <div class="font-weight-medium">
                                                {{ colorRowsTitle }}
                                            </div>

                                            <div
                                                class="
                                                    text-caption
                                                    grey--text
                                                "
                                            >
                                                Izberite barvo besedila
                                            </div>
                                        </div>
                                    </div>


                                    <!-- MAX LENGTH -->
                                    <div class="info-row">
                                        <v-avatar
                                            size="40"
                                            color="blue lighten-5"
                                            class="mr-3"
                                        >
                                            <v-icon color="primary">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </v-avatar>

                                        <div>
                                            <div class="font-weight-medium">
                                                Največ
                                                {{ maxCharactersPerRow }}
                                                znakov
                                            </div>

                                            <div
                                                class="
                                                    text-caption
                                                    grey--text
                                                "
                                            >
                                                Na posamezno vrstico
                                            </div>
                                        </div>
                                    </div>


                                    <!-- LIVE PREVIEW -->
                                    <div class="info-row mb-0">
                                        <v-avatar
                                            size="40"
                                            color="blue lighten-5"
                                            class="mr-3"
                                        >
                                            <v-icon color="primary">
                                                mdi-eye-outline
                                            </v-icon>
                                        </v-avatar>

                                        <div>
                                            <div class="font-weight-medium">
                                                Predogled v živo
                                            </div>

                                            <div
                                                class="
                                                    text-caption
                                                    grey--text
                                                "
                                            >
                                                Spremembe so takoj vidne desno
                                            </div>
                                        </div>
                                    </div>

                                </v-card-text>
                            </v-card>


                            <!-- INFO ALERT -->
                            <v-alert
                                type="info"
                                dense
                                class="mt-5 mb-0"
                            >
                                <div class="font-weight-medium">
                                    O PRIKAZOVALNIKU
                                </div>

                                <div class="text-body-2 mt-1">
                                    Prikazovalnik
                                    <strong>
                                        {{ display.name }}
                                    </strong>
                                    vsebuje
                                    {{ rows.length }}
                                    {{
                                        rows.length === 1
                                            ? 'vrstico'
                                            : 'vrstic'
                                    }}.
                                </div>

                                <div class="text-body-2 mt-1">
                                    Največja dovoljena dolžina
                                    posamezne vrstice je
                                    {{ maxCharactersPerRow }}
                                    znakov.
                                </div>

                                <div class="text-body-2 mt-1">
                                    Trenutno stanje:
                                    <strong>
                                        {{
                                            display.is_on
                                                ? 'PRIŽGAN'
                                                : 'UGASNJEN'
                                        }}
                                    </strong>
                                </div>

                                <div
                                    class="
                                        text-body-2
                                        font-weight-medium
                                        mt-1
                                    "
                                >
                                    Spremembe bodo shranjene po
                                    kliku na SHRANI SPREMEMBE.
                                </div>
                            </v-alert>

                        </v-col>
                    </v-row>

                </v-flex>
            </v-layout>


            <!-- SNACKBAR -->
            <v-snackbar
                v-model="snackbar.show"
                :timeout="5000"
                bottom
                right
                :color="snackbar.color"
            >
                {{ snackbar.text }}

                <template
                    v-slot:action="{ attrs }"
                >
                    <v-btn
                        text
                        v-bind="attrs"
                        @click="
                            snackbar.show = false
                        "
                    >
                        Zapri
                    </v-btn>
                </template>
            </v-snackbar>

        </v-container>
    </div>
</template>


<script>
export default {
    name: 'TrafficLights',


    data() {
        return {
            loading: false,
            saving: false,
            isDirty: false,

            displayBoards: [],

            selectedDisplayUuid: null,

            display: null,

            rows: [],

            originalRows: [],

            originalDisplayIsOn: true,

            snackbar: {
                show: false,
                text: '',
                color: '',
            },
        };
    },


    computed: {
        maxCharactersPerRow() {
            if (
                !this.display ||
                !this.display.max_characters_per_row
            ) {
                return 25;
            }

            return parseInt(
                this.display.max_characters_per_row,
                10
            );
        },


        textRowNumbers() {
            return this.rows
                .filter(
                    row =>
                        !this.hasColorSelection(row)
                )
                .map(
                    row => row.row_number
                );
        },


        colorRowNumbers() {
            return this.rows
                .filter(
                    row =>
                        this.hasColorSelection(row)
                )
                .map(
                    row => row.row_number
                );
        },


        textRowsTitle() {
            return this.formatRowsTitle(
                this.textRowNumbers
            );
        },


        colorRowsTitle() {
            return this.formatRowsTitle(
                this.colorRowNumbers
            );
        },


        usedColors() {
            const colors = [];

            this.rows.forEach(row => {
                const allowedColors =
                    Array.isArray(
                        row.allowed_colors
                    )
                        ? row.allowed_colors
                        : [];

                allowedColors.forEach(
                    color => {
                        if (
                            colors.indexOf(
                                color
                            ) === -1
                        ) {
                            colors.push(
                                color
                            );
                        }
                    }
                );
            });


            if (
                this.textRowNumbers.length > 0 &&
                colors.indexOf('white') === -1
            ) {
                colors.unshift(
                    'white'
                );
            }


            return colors;
        },
    },


    created() {
        this.$store.dispatch(
            'ROUTE_NAME',
            this.$route.name
        );

        this.loadDisplayBoards();
    },


    methods: {
        async loadDisplayBoards() {
            this.loading = true;

            try {
                const response =
                    await this.$store.dispatch(
                        'DISPLAY_BOARDS'
                    );


                if (
                    !response.data ||
                    response.data.success !== true
                ) {
                    throw new Error(
                        'Invalid API response.'
                    );
                }


                this.displayBoards =
                    response.data.data || [];


                if (
                    this.displayBoards.length > 0
                ) {
                    this.selectedDisplayUuid =
                        this.displayBoards[0].uuid;

                    this.selectDisplay(
                        this.selectedDisplayUuid
                    );
                }

            } catch (error) {
                console.error(error);

                this.showMessage(
                    'Pri nalaganju prikazovalnikov je prišlo do napake.',
                    'error'
                );

            } finally {
                this.loading = false;
            }
        },


        selectDisplay(uuid) {
            const selectedDisplay =
                this.displayBoards.find(
                    item =>
                        item.uuid === uuid
                );


            if (!selectedDisplay) {
                return;
            }


            this.selectedDisplayUuid =
                uuid;


            this.display =
                JSON.parse(
                    JSON.stringify(
                        selectedDisplay
                    )
                );


            /*
             * Poskrbimo, da je is_on vedno boolean.
             */
            this.display.is_on =
                selectedDisplay.is_on === true ||
                selectedDisplay.is_on === 1 ||
                selectedDisplay.is_on === '1';


            /*
             * Original ON/OFF stanje za PREKLIČI.
             */
            this.originalDisplayIsOn =
                this.display.is_on;


            /*
             * Backend lahko vrne active_rows
             * ali rows.
             */
            const backendRows =
                this.display.active_rows ||
                this.display.rows ||
                [];


            this.rows =
                backendRows.map(row => {
                    let allowedColors =
                        row.allowed_colors;


                    if (
                        typeof allowedColors ===
                        'string'
                    ) {
                        try {
                            allowedColors =
                                JSON.parse(
                                    allowedColors
                                );
                        } catch (error) {
                            console.error(
                                error
                            );

                            allowedColors = [];
                        }
                    }


                    if (
                        !Array.isArray(
                            allowedColors
                        )
                    ) {
                        allowedColors = [];
                    }


                    let color =
                        row.color;


                    if (!color) {
                        color = 'white';
                    }


                    return {
                        id:
                            row.id,

                        display_board_id:
                            row.display_board_id,

                        row_number:
                            row.row_number,

                        label:
                            row.label,

                        type:
                            row.type,

                        text:
                            row.text || '',

                        color:
                            color,

                        allowed_colors:
                            allowedColors,

                        sort_order:
                            row.sort_order,

                        is_active:
                            row.is_active,
                    };
                });


            this.rows.sort(
                (a, b) => {
                    const sortA =
                        parseInt(
                            a.sort_order,
                            10
                        ) ||
                        parseInt(
                            a.row_number,
                            10
                        );

                    const sortB =
                        parseInt(
                            b.sort_order,
                            10
                        ) ||
                        parseInt(
                            b.row_number,
                            10
                        );

                    return sortA - sortB;
                }
            );


            this.storeOriginalRows();

            this.isDirty = false;
        },


        storeOriginalRows() {
            this.originalRows =
                JSON.parse(
                    JSON.stringify(
                        this.rows
                    )
                );
        },


        markDirty() {
            this.isDirty = true;
        },


        resetChanges() {
            this.rows =
                JSON.parse(
                    JSON.stringify(
                        this.originalRows
                    )
                );


            this.display.is_on =
                this.originalDisplayIsOn;


            this.isDirty = false;


            this.showMessage(
                'Spremembe so bile preklicane.',
                ''
            );
        },


        hasColorSelection(row) {
            if (
                Array.isArray(
                    row.allowed_colors
                ) &&
                row.allowed_colors.length > 1
            ) {
                return true;
            }


            return (
                row.type === 'status' ||
                row.type === 'color'
            );
        },


        previewClass(row) {
            if (
                !this.hasColorSelection(row)
            ) {
                return 'preview-white';
            }


            if (
                row.color === 'red'
            ) {
                return 'preview-red';
            }


            if (
                row.color === 'green'
            ) {
                return 'preview-green';
            }


            return 'preview-white';
        },


        colorLabel(color) {
            const mobileLabels = {
                white:
                    'BELA',

                red:
                    'RDEČA',

                green:
                    'ZELENA',
            };


            const desktopLabels = {
                white:
                    'BELA (white)',

                red:
                    'RDEČA (red)',

                green:
                    'ZELENA (green)',
            };


            if (
                this.$vuetify.breakpoint.xsOnly
            ) {
                return (
                    mobileLabels[color] ||
                    color.toUpperCase()
                );
            }


            return (
                desktopLabels[color] ||
                color.toUpperCase()
            );
        },


        colorButtonClass(
            row,
            color
        ) {
            if (
                row.color !== color
            ) {
                return '';
            }


            if (
                color === 'white'
            ) {
                return 'white-selected';
            }


            if (
                color === 'red'
            ) {
                return 'red white--text';
            }


            if (
                color === 'green'
            ) {
                return 'green white--text';
            }


            return '';
        },


        colorIconColor(
            row,
            color
        ) {
            if (
                color === 'white' &&
                row.color === 'white'
            ) {
                return 'blue-grey darken-2';
            }


            if (
                row.color === color
            ) {
                return 'white';
            }


            if (
                color === 'white'
            ) {
                return 'blue-grey lighten-1';
            }


            return color;
        },


        formatRowsTitle(numbers) {
            if (
                !numbers.length
            ) {
                return '';
            }


            if (
                numbers.length === 1
            ) {
                return (
                    'Vrstica ' +
                    numbers[0]
                );
            }


            return (
                'Vrstice ' +
                numbers.join(', ')
            );
        },


        buildUpdatePayload() {
            const rows =
                Array.isArray(this.rows)
                    ? this.rows
                    : [];


            return {
                is_on:
                    this.display.is_on,

                rows:
                    rows.map(row => {
                        return {
                            id:
                                row.id,

                            text:
                                row.text || '',

                            color:
                                row.color || 'white',
                        };
                    }),
            };
        },


        async save() {
            if (
                !this.display ||
                !this.display.uuid
            ) {
                return;
            }


            const invalidRow =
                this.rows.find(
                    row => {
                        return (
                            (
                                row.text || ''
                            ).length >
                            this.maxCharactersPerRow
                        );
                    }
                );


            if (invalidRow) {
                this.showMessage(
                    'Besedilo v vrstici ' +
                    invalidRow.row_number +
                    ' je predolgo.',
                    'error'
                );

                return;
            }


            this.saving = true;


            try {
                const payload =
                    this.buildUpdatePayload();


                const response =
                    await this.$store.dispatch(
                        'UPDATE_DISPLAY_BOARD',
                        {
                            uuid:
                                this.display.uuid,

                            payload:
                                payload,
                        }
                    );


                if (
                    !response.data ||
                    response.data.success !== true
                ) {
                    throw new Error(
                        'Invalid API response.'
                    );
                }


                /*
                 * Trenutno stanje je uspešno shranjeno.
                 * Ne reloadamo displaya iz response-a,
                 * da UI ne skoči nazaj na stare vrednosti.
                 */
                this.storeOriginalRows();

                this.originalDisplayIsOn =
                    this.display.is_on;

                this.isDirty = false;


                this.showMessage(
                    response.data.message ||
                    'Spremembe so bile uspešno shranjene.',
                    'success'
                );

            } catch (error) {
                console.error(error);


                let message =
                    'Pri shranjevanju je prišlo do napake.';


                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                ) {
                    message =
                        error.response.data.message;
                }


                if (
                    error.response &&
                    error.response.status === 422 &&
                    error.response.data &&
                    error.response.data.errors
                ) {
                    const errors =
                        error.response.data.errors;


                    const firstKey =
                        Object.keys(
                            errors
                        )[0];


                    if (
                        firstKey &&
                        errors[firstKey] &&
                        errors[firstKey][0]
                    ) {
                        message =
                            errors[firstKey][0];
                    }
                }


                this.showMessage(
                    message,
                    'error'
                );

            } finally {
                this.saving = false;
            }
        },


        showMessage(
            text,
            color
        ) {
            this.snackbar = {
                show:
                    true,

                text:
                    text,

                color:
                    color || '',
            };
        },
    },
};
</script>


<style scoped>
.display-row {
    padding:
        22px 18px;

    border-bottom:
        1px solid #e5e7eb;
}


.display-row:last-child {
    border-bottom:
        none;
}


/**
 * COLOR TOGGLE
 */
.color-toggle {
    width:
        100%;

    display:
        flex;
}


.color-toggle .v-btn {
    flex:
        1 1 33.333%;
}


.color-btn {
    min-width:
        0 !important;
}


/**
 * WHITE selected
 */
.white-selected {
    background-color:
        #ffffff !important;

    color:
        #37474f !important;

    border:
        1px solid #90a4ae !important;
}


/**
 * DISPLAY PREVIEW
 */
.display-preview {
    position:
        relative;

    background:
        linear-gradient(
            180deg,
            #2d2f30 0%,
            #232526 100%
        );

    border:
        1px solid #1b1b1b;

    border-radius:
        4px;

    padding:
        14px 18px;

    box-shadow:
        inset
        0
        0
        20px
        rgba(
            0,
            0,
            0,
            0.45
        );
}


.display-preview-off .preview-row {
    opacity:
        0.15;
}


/**
 * OFF OVERLAY
 */
.display-off-overlay {
    position:
        absolute;

    z-index:
        5;

    top:
        0;

    left:
        0;

    right:
        0;

    bottom:
        0;

    display:
        flex;

    flex-direction:
        column;

    align-items:
        center;

    justify-content:
        center;

    color:
        #ffffff;

    font-weight:
        600;

    text-align:
        center;

    background:
        rgba(
            0,
            0,
            0,
            0.35
        );

    border-radius:
        4px;
}


/**
 * PREVIEW ROW
 */
.preview-row {
    min-height:
        62px;

    display:
        flex;

    align-items:
        center;

    border-bottom:
        1px dotted
        rgba(
            255,
            255,
            255,
            0.22
        );
}


.preview-row:last-child {
    border-bottom:
        none;
}


/**
 * PREVIEW TEXT
 */
.preview-text {
    flex:
        1;

    text-align:
        center;

    font-size:
        26px;

    line-height:
        1.2;

    font-weight:
        500;

    word-break:
        break-word;

    text-shadow:
        0
        0
        6px
        rgba(
            255,
            255,
            255,
            0.08
        );
}


/**
 * PREVIEW NUMBER
 */
.preview-number {
    width:
        20px;

    flex:
        0 0 20px;

    text-align:
        right;

    font-size:
        13px;

    color:
        rgba(
            255,
            255,
            255,
            0.35
        );

    margin-left:
        15px;
}


/**
 * PREVIEW COLORS
 */
.preview-white {
    color:
        #ffffff;

    text-shadow:
        0
        0
        8px
        rgba(
            255,
            255,
            255,
            0.20
        );
}


.preview-red {
    color:
        #f44336;

    text-shadow:
        0
        0
        8px
        rgba(
            244,
            67,
            54,
            0.25
        );
}


.preview-green {
    color:
        #66bb4a;

    text-shadow:
        0
        0
        8px
        rgba(
            102,
            187,
            74,
            0.25
        );
}


/**
 * LEGEND
 */
.legend {
    display:
        flex;

    flex-direction:
        column;

    gap:
        8px;
}


.legend-item {
    display:
        flex;

    align-items:
        center;

    font-size:
        14px;

    color:
        #4b5563;
}


.legend-dot {
    width:
        12px;

    height:
        12px;

    border-radius:
        50%;

    margin-right:
        10px;

    display:
        inline-block;
}


.white-dot {
    background:
        #ffffff;

    border:
        1px solid #90a4ae;
}


.red-dot {
    background:
        #f44336;
}


.green-dot {
    background:
        #66bb4a;
}


/**
 * NAVODILA
 */
.info-row {
    display:
        flex;

    align-items:
        center;

    margin-bottom:
        24px;
}


/**
 * RESPONSIVE
 */
@media (
    max-width: 960px
) {
    .display-row {
        padding:
            18px 12px;
    }

    .preview-text {
        font-size:
            22px;
    }
}


@media (
    max-width: 600px
) {
    .preview-row {
        min-height:
            52px;
    }

    .preview-text {
        font-size:
            18px;
    }

    .color-toggle {
        display:
            flex;

        flex-direction:
            column;

        width:
            100%;
    }

    .color-toggle .v-btn {
        width:
            100%;

        flex:
            none !important;

        min-height:
            44px;

        margin-bottom:
            6px;
    }

    .color-toggle .v-btn:last-child {
        margin-bottom:
            0;
    }

    .color-btn {
        min-width:
            100% !important;

        justify-content:
            flex-start;

        padding-left:
            16px !important;

        padding-right:
            16px !important;
    }
}
</style>